module.exports = __webpack_public_path__ + "static/media/carte_bulgarie.cd7d0125.svg";